import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const initialState = {
  languages: []
}

const getters = {
  languages: state => state.languages
}

const mutations = {
  languages: (state, languages) => {
    state.languages = languages
  }
}

const actions = {
  async fetchLanguages({ commit }) {
    const response = await axios.get(`${config.getRootApi()}/languages`)
    commit('languages', response.data)
  },
  async createLanguage({ commit, state }, name) {
    const response = await axios.post(`${config.getRootApi()}/languages`, { name: name })
    if (response.status === 201) {
      const newLanguage = response.data
      commit('languages', [...state.languages, newLanguage])
      return newLanguage
    } else {
      console.error('Could not create language')
    }
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
